// extracted by mini-css-extract-plugin
export default {"maindiv":"Upload_maindiv__d4mMl","singleUpload":"Upload_singleUpload__zuXH7","multipleUpload":"Upload_multipleUpload__y4U9J","msz":"Upload_msz__QVStX"};